import "./edit/online-container-edit.module";

angular.module("thor.online-containers", ["thor.online-container-edit"]);
